// _____________________________________
//   colors
// _____________________________________
// black
export const black = '#000000';
// primaryGreen colors
export const primaryGreen_900 = '#04120f';
export const primaryGreen_800 = '#0e3c31';
export const primaryGreen_700 = '#176554';
export const primaryGreen_600 = '#208f76';
export const primaryGreen_500 = '#1C856D';
export const primaryGreen_400 = '#51d2b5';
export const primaryGreen_300 = '#7bdac5';
export const primaryGreen_200 = '#a3eddc';
export const primaryGreen_100 = '#bef0e5';
export const primaryGreen_50 = '#e7faf5';
export const primaryGreen_30 = '#f5fdfb';
// primaryBlue colors
export const primaryBlue_500 = '#0069ff';
export const primaryBlue_400 = '#3387ff';
export const primaryBlue_300 = '#66a5ff';
export const primaryBlue_200 = '#99c3ff';
export const primaryBlue_100 = '#cce1ff';
export const primaryBlue_50 = '#eef5ff';
export const primaryBlue_30 = '#f6faff';
// primaryOrange colors
export const primaryOrange_500 = '#8A5300';
export const primaryOrange_400 = '#BC7100';
export const primaryOrange_300 = '#A76708';
export const primaryOrange_200 = '#FAB043';
export const primaryOrange_100 = '#FFD79A';
export const primaryOrange_50 = '#FFF1DB';
export const primaryOrange_30 = '#FFF7EB';
// primaryEggplant colors
export const primaryEggplant_600 = '#652C88';
export const primaryEggplant_500 = '#793F9D';
export const primaryEggplant_400 = '#975EBB';
export const primaryEggplant_300 = '#B384CF';
export const primaryEggplant_200 = '#D0ABE7';
export const primaryEggplant_100 = '#E7D3F4';
export const primaryEggplant_50 = '#F9F0FE';
export const primaryEggplant_30 = '#FCF6FF';
// BlueGray colors
export const BlueGray_800 = '#333333';
export const BlueGray_700 = '#434343';
export const BlueGray_600 = '#5C5C5C';
export const BlueGray_500 = '#6D6D6D';
export const BlueGray_400 = '#767676';
export const BlueGray_300 = '#A0A0A0';
export const BlueGray_200 = '#727272';
export const BlueGray_100 = '#dbdbdb';
export const BlueGray_50 = '#e4e4e4';
export const BlueGray_30 = '#f5f5f5';
export const BlueGray_0 = '#FFFFFF';
// secondary colors
export const light_green = '#41d4b3';
export const light_red = '#e86a6a';
export const light_purple = '#978cfc';
export const yellow = '#fdc500';
export const light_yellow = '#FFC048';
// text colors
export const text_900 = '#101010';
export const text_800 = '#333';
export const text_600 = '#5c5c5c';
export const text_400 = '#888';
export const text_300 = '#a0a0a0';
export const text_200 = '#c8c8c8';
// other colors
export const notice_orange = '#AA643D';
export const notice_red_dark = '#8a2d18';
export const notice_red = '#e12700';
export const notice_red_light = '#e75134';
export const white = '#FFFFFF';

// _____________________________________
//   notice
// _____________________________________

export const notice_warning = notice_orange;
export const notice_error = notice_red;
